import React, { useState } from 'react'
import { useAuth } from '../contexts/AuthContext'
import { Button } from './ui/button'
import { PhoneInput, PasswordInput } from '@pocketbloom/shared-ui'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card'
import { Alert, AlertDescription } from './ui/alert'

export const LoginForm: React.FC = () => {
  const [emailOrPhone, setEmailOrPhone] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const { login } = useAuth()

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError('')
    setIsLoading(true)

    try {
      await login(emailOrPhone, password)
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Giriş xətası')
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle>Admin panelinə giriş</CardTitle>
          <CardDescription>İdarəetmə sisteminə daxil olmaq üçün telefon və şifrəni daxil edin</CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4">
            {error && (
              <Alert variant="destructive">
                <AlertDescription>{error}</AlertDescription>
              </Alert>
            )}

            <div>
              <PhoneInput
                value={emailOrPhone}
                onChange={(value) => setEmailOrPhone(value)}
                placeholder="+994 50 123 45 67"
                showValidation={true}
                autoComplete="username"
              />
            </div>

            <div>
              <PasswordInput
                placeholder="Şifrə"
                value={password}
                onChange={(value) => setPassword(value)}
                required
                autoComplete="current-password"
              />
            </div>

            <Button type="submit" className="w-full" disabled={isLoading}>
              {isLoading ? 'Giriş...' : 'Daxil ol'}
            </Button>
          </form>

          <div className="mt-4 text-sm text-gray-600">
            <p>Test məlumatları:</p>
            <p>Telefon: +994 50 123 45 67</p>
            <p>Şifrə: admin123</p>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}

